import { createRoleThunks } from "./roleSliceFactory";
import {
  LANDLORD_ENDPOINTS,
  ROLE_COLLECTION_KEYS,
} from "../types/roles";

const slice = createRoleThunks(
  "landlord",
  LANDLORD_ENDPOINTS,
  ROLE_COLLECTION_KEYS.landlord
);

export const landlordThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const landlordActions = slice.actions;

export default slice.reducer;
